import { render } from "./ParticipationIcon.vue?vue&type=template&id=5e3896e6&scoped=true"
import script from "./ParticipationIcon.vue?vue&type=script&lang=js"
export * from "./ParticipationIcon.vue?vue&type=script&lang=js"

import "./ParticipationIcon.vue?vue&type=style&index=0&id=5e3896e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3896e6"]])

export default __exports__